import React from "react";
import { JUDGE_1, MISSION, VISION } from "../../assets";
import ButtonV2 from "../../shared/components/buttonV2";

function Welcome() {
  return (
    <>
      <div className="py-8 sm:py-10 px-4 sm:px-8 lg:px-32 flex flex-col lg:flex-row items-center lg:items-start justify-between gap-8 lg:gap-0 lg:-space-x-5">
        <div className="w-full flex flex-col items-center justify-center gap-y-2 order-2 lg:order-1">
          <img
            src={JUDGE_1}
            className="w-[280px] sm:w-[320px] rounded-lg object-contain"
            alt="Hon. Justice George Chibueze Nnamani"
          />
          <div className="flex flex-col justify-center gap-y-2 sm:gap-y-3 items-center mt-3 px-4 text-center">
            <span className="text-base sm:text-lg font-semibold text-globalGreen">
              Hon. Justice George Chibueze Nnamani, FCIArb
            </span>
            <span className="text-xs sm:text-sm font-medium text-gray-regular text-center leading-relaxed">
              President, Customary Court of Appeal, Enugu State
            </span>
          </div>
        </div>
        <div className="w-full px-4 sm:px-6 lg:px-10 order-1 lg:order-2">
          <div className="flex flex-col items-start gap-y-3">
            <span className="text-xl sm:text-2xl lg:text-3xl font-semibold leading-tight">
              WELCOME TO ENUGU STATE CUSTOMARY COURT OF APPEAL
            </span>
            <span className="text-xs sm:text-sm w-full lg:w-[26rem] font-medium text-gray-regular text-justify leading-relaxed">
              The Enugu State Customary Court of Appeal is a superior court of
              record established under the Constitution of the Federal Republic
              of Nigeria (1999, as amended). The Court hears appeals from
              Customary Courts within Enugu State and exercises supervisory
              jurisdiction over matters governed by customary law. We are
              committed to fair, timely, and transparent justice in accordance
              with the customs of the people of Enugu State and the
              Constitution.
            </span>
          </div>
          <ButtonV2
            btnStyle={`w-fit px-3.5 py-2 mt-6 sm:mt-8 lg:mt-10
                rounded-3xl border border-globalGreen flex items-center justify-center`}
            textStyle={`
                   text-globalGreen
                  font-medium text-sm`}
            title="Read More"
            handleClick={() => {}}
          />
        </div>
      </div>
      <div className="mt-5 flex flex-col lg:flex-row items-center lg:items-start justify-center gap-6 px-4 sm:px-8 lg:px-20">
        <div className="w-full lg:max-w-[500px] h-auto lg:h-[350px] p-4 sm:p-5 flex flex-col lg:flex-row shadow-blur lg:-space-x-3 bg-white rounded-xl border-t-[2px] border-globalGreen rounded-t-2xl items-center lg:items-start gap-y-4 lg:gap-y-2">
          <img src={MISSION} className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px]" alt="Mission Icon" />
          <div className="flex flex-col gap-y-3 sm:gap-y-4 items-center lg:items-start text-center lg:text-left">
            <span className="text-[14px] sm:text-[16px] font-semibold text-black">
              Mission
            </span>
            <span className="text-gray-regular font-medium text-xs sm:text-sm text-justify leading-relaxed">
              The Customary Court of Appeal, Enugu State, is committed to
              administering justice rooted in the enduring values, customs, and
              traditions of our people. We strive to interpret and apply
              customary law with intellectual depth, cultural insight, and
              constitutional balance—ensuring fairness, accessibility, and
              integrity in every decision. Our mission is to preserve the moral
              fabric of our communities while advancing a judicial culture that
              is both responsive and respected, now and for generations to come.
            </span>
          </div>
        </div>
        <div className="w-full lg:max-w-[500px] h-auto lg:h-[350px] p-4 sm:p-5 flex flex-col lg:flex-row shadow-blur lg:-space-x-3 bg-white rounded-xl border-t-[2px] border-globalGreen rounded-t-2xl items-center lg:items-start justify-start gap-y-4 lg:gap-y-2">
          <img src={VISION} className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px]" alt="Vision Icon" />
          <div className="flex flex-col gap-y-3 sm:gap-y-4 items-center lg:items-start text-center lg:text-left">
            <span className="text-[14px] sm:text-[16px] font-semibold text-black">
              Vision
            </span>
            <span className="text-gray-regular font-medium text-xs sm:text-sm text-justify leading-relaxed">
              To be a model of excellence in customary law adjudication—a court
              where indigenous justice systems and constitutional principles
              converge to shape a fair, just, and culturally vibrant society. We
              envision a future where the Customary Court of Appeal of Enugu
              State leads in judicial innovation, commands public trust, and
              upholds a living legacy of law that speaks to both tradition and
              transformation.
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Welcome;
